import { ShopSwitch } from '@ts/components/ShopSwitch';
import { Navigation } from '@ts/components/Navigation';
import { Modal } from '@ts/components/Modal';

export const init = () => {
    setShopSwitch();
}

const setShopSwitch = () => {
    ShopSwitch.create('.shop-selector-trigger', { openOnHover: true });
    setOpenCartTrigger();
    setShopNavigationLinks();
    setActiveShopLink();
}

const setActiveShopLink = () => {
    const activeShopLink = document.querySelector('.active-shop-label a');
    if (!activeShopLink) return;

    activeShopLink.addEventListener('click', event => {
        event.stopPropagation();
    });
}

const setOpenCartTrigger = () => {
    const cartTrigger = document.querySelector('.nav-shopping-cart a');
    if (!cartTrigger) return;
    cartTrigger.addEventListener('click', (e) => {
        e.preventDefault();
        Navigation.close();
    });
}  

const setShopNavigationLinks = () => {
    const shopAccessLinks = document.querySelectorAll('.shop-access-link:not(.disabled)');
    if (shopAccessLinks.length === 0) return;
    
    let inProgress = false;

    const setLinksBusy = (busy) => {
        shopAccessLinks.forEach(link => {
            link.classList.toggle('loading', busy);
            link.setAttribute('aria-disabled', busy ? 'true' : 'false');
        });
    };

    shopAccessLinks.forEach(link => {
        link.addEventListener('click', async (e) => {
            e.preventDefault();
            const accessLink = link.getAttribute('data-shop-access-url');

            // Bail on any in links being retrieved
            if (inProgress || !accessLink) return;
            inProgress = true;
            setLinksBusy(true);

            try {
                const newShopLink = await getAccessLink(accessLink);    
                if (!newShopLink) return;
                
                const checkCartContentsEndpoint = shopAccessLinks[0]?.closest('form')?.dataset?.checkCartContentsUrl;
                if (!checkCartContentsEndpoint) {
                    window.location.href = newShopLink;
                    return;
                }

                const cartItemCount = await getCartContents(checkCartContentsEndpoint);
                
                if (!cartItemCount || link.classList.contains('active')) {
                    window.location.href = newShopLink;
                    return;
                }
                
                ShopSwitch.getShopSwitch('shop-selector-trigger')?.close();
                Modal.create('#cart-warning-modal', {
                    modalSize: 'modal-sm',
                    modalTitle: 'Switch Shops?',
                    onOpen: () => {
                        const changeShopBtn = document.querySelector('.modal-content #change-shops-btn');  
                        if (!changeShopBtn) return;
                        changeShopBtn.setAttribute('href', newShopLink);
                    }
                });
            } catch (error) {
                console.error('Error handling shop access link click:', error);
            } finally {
                inProgress = false;
                setLinksBusy(false);
            }
        });
    });

    const disabledShopAccessLinks = document.querySelectorAll('.shop-access-link.disabled');
    disabledShopAccessLinks.forEach(link => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
        });
    });
}

const getCartContents = async (endpoint) => {
    return fetch(endpoint)
        .then(response => response.json())
        .then(data => {
            return data.count;
        })
        .catch(error => {
            console.error('Error fetching cart contents:', error);
            Modal.createAlertModal({
                title: 'Error',
                message: 'There was an error checking your cart contents. Please try again later.',
                closeBtnLabel: 'Close'
            });
            return false;
        });
}

const getAccessLink = async (endpoint) => {
    try {
        const response = await fetch(endpoint);
        if (!response.ok) {
            throw new Error('There was an error retrieving the shop link');
        }

        const data = await response.json();

        if (data && data.url) {
            return data.url;
        }

        Modal.createAlertModal({
            title: 'Error',
            message: 'There was an error retrieving the shop link. Please try again later.',
            closeBtnLabel: 'Close'
        });

        return null;
    } catch (error) {
        
        console.error('Error fetching access link:', error);

        Modal.createAlertModal({
            title: 'Error',
            message: 'There was an error retrieving the shop link.',
            closeBtnLabel: 'Close'
        });

        return null;
    }
}